import { E_THEME } from '@common/configs';
import { classesBuilder } from '@common/helpers';
import BaseButton from '@components/Button/BaseButton';
import LanguageSwitch from '@components/LanguageSwitch';
import ReportActions from '@components/ReportActions';

import { useHeaderMenu } from '../helpers';

import headerStyle from '../styles.module.scss';
import style from './styles.module.scss';

const MobileMenu = () => {
  const { isMenuOpen, isMenuClosing, onMenuToggle, onMenuClose, onAnimationEnd } = useHeaderMenu();

  return (
    <>
      {(isMenuOpen || isMenuClosing) && (
        <div
          className={style.wrapper}
          onClick={onMenuClose}
        >
          <div
            className={classesBuilder(style.menu, {
              [style.open]: isMenuOpen,
              [style.close]: isMenuClosing,
            })}
            onClick={(element) => {
              return element.stopPropagation();
            }}
            onAnimationEnd={onAnimationEnd}
          >
            <div className={style.content}>
              <ReportActions />
              <div className={style['language-contact-wrapper']}>
                <LanguageSwitch theme={E_THEME.LIGHT} />
                <BaseButton className={headerStyle.contact}>Contact</BaseButton>
              </div>
            </div>
          </div>
        </div>
      )}

      <button
        className={classesBuilder(style['menu-button'], {
          [style.open]: isMenuOpen,
        })}
        onClick={onMenuToggle}
        aria-label={isMenuOpen ? 'Close Menu' : 'Open Menu'}
        aria-expanded={isMenuOpen}
      >
        <div className={style.icon}></div>
      </button>
    </>
  );
};

export default MobileMenu;
